export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-social-skillshare-5d70e64ac77414abd3432d2864e02299.svg";